<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <v-card class="pa-2 ma-3" elevation="2">
                    <v-card-title>{{ t('Detalles_del_usuario') }}</v-card-title>
                    <v-card-text>
                        <v-text-field v-model="userDetails.email" readonly :label="t('Email')"></v-text-field>
                        <v-text-field v-model="userDetails.first_name" readonly :label="t('Nombre')"
                            required></v-text-field>
                        <v-text-field v-model="userDetails.last_name" readonly :label="t('Apellidos')"
                            required></v-text-field>
                        <v-text-field v-model="userDetails.institucion_nombre" readonly
                            :label="t('Insitución')"></v-text-field>
                        <v-text-field v-model="rolesString" readonly :label="t('Rol')" />
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { useI18n } from 'vue-i18n';
import { useUserStore } from '@/stores/user';
import { computed } from 'vue';

const userStore = useUserStore();
const { t } = useI18n();

const userDetails = computed(() => userStore.userDetails);

const rolesString = computed(() => {
    const roles = userDetails.value?.roles;
    return Array.isArray(roles) ? roles.join(', ') : '';
});

</script>